{
  "uploading_progress": "Se încarcă... {current}/{total}",
  "uploading_warning": "⚠️ NU închide pagina și NU apăsa Salvează până când toate imaginile sunt încărcate!",
  "add_photos_title": "Adaugă Fotografii ({count}/{max})",
  "drag_drop_hint": "Trage și lasă imaginile aici sau fă click pentru a selecta",
  "auto_optimization": "Optimizare automată WebP • Compresie până la 90%",
  "select_images_btn": "Selectează imagini",
  "processing_btn": "Se procesează...",
  "images_uploaded_count": "{count} imagine/i încărcate - poți salva anunțul",
  "optimization_active_title": "Optimizare automată activă",
  "images_processed": "Imagini procesate",
  "original_size": "Dimensiune originală",
  "after_optimization": "După optimizare",
  "space_saved": "Spațiu economisit",
  "speed_improvement": "⚡ Site-ul se va încărca {factor}x mai rapid • SEO îmbunătățit",
  "image_alt": "Imagine {index}",
  "main_image_badge": "Imagine principală",
  "auto_optimization_title": "Optimizare automată",
  "format_info": "Acceptăm orice (JPG, PNG, WebP, HEIC) → convertim la WebP",
  "resolution_info": "Orice dimensiune → optimizăm automat la 1920px",
  "size_info": "Maximum 20 MB → compresăm automat",
  "forbidden_info": "Poze cu text de contact (telefon, WhatsApp)",
  "format_label": "Format:",
  "resolution_label": "Rezoluție:",
  "size_label": "Mărime:",
  "forbidden_label": "INTERZIS:",
  "recommended_order_title": "Ordine automată recomandată",
  "order_1": "1. Exterior hero",
  "order_1_desc": "vedere 3/4 față",
  "order_2": "2. Față",
  "order_2_desc": "frontal complet",
  "order_3": "3. Spate",
  "order_3_desc": "posterior complet",
  "order_4": "4. Laterale",
  "order_4_desc": "ambele părți",
  "order_5": "5. Interior",
  "order_5_desc": "bord, scaune, portbagaj",
  "order_6": "6. Detalii",
  "order_6_desc": "motor, roți, kilometraj",
  "order_7": "7. Defecte",
  "order_7_desc": "zgârieturi, lovituri (dacă există)",
  "auto_sort_hint": "💡 Sortare automată activă - denumește fișierele descriptiv!",
  "photo_guide_title": "Ghid complet fotografie auto",
  "photo_guide_subtitle": "Tutorial PDF cu exemple și șabloane",
  "download_pdf": "Descarcă PDF",
  "error_title": "Eroare",
  "error_auth_required": "Trebuie să fii autentificat pentru a încărca imagini",
  "error_upload": "Nu s-a putut încărca imaginea",
  "error_heic": "Formatul HEIC nu este suportat. Vă rugăm să convertiți la JPG din Setări → Cameră → Formate → Cel mai compatibil",
  "error_process": "Nu s-a putut procesa imaginea. Încercați cu o imagine mai mică.",
  "error_delete": "Nu s-a putut șterge imaginea",
  "error_upload_title": "Eroare upload",
  "error_invalid_file": "Fișier invalid",
  "error_only_images": "❌ Doar fișiere imagine sunt permise (JPG, PNG, WebP, HEIC, etc.)",
  "error_max_images": "Maxim {max} imagini permise",
  "error_file_too_large": "❌ Fișier prea mare: {size}. Maximum 20 MB.",
  "error_suspicious_name": "⚠️ Nume fișier suspect (posibil text contact). Redenumește fișierul.",
  "success_optimized": "Imagine optimizată și încărcată!",
  "success_uploaded": "✅ Imagini încărcate cu succes!",
  "success_uploaded_desc": "{count} imagini adăugate. Total: {total} imagini."
}